// src/services/scheduledMessages.service.js
import { request } from "./http";

// API_URL عندك فيه /api بالفعل، فهنا نستخدم paths بدون /api
const BASE = "/ScheduledMessages";

const pickData = (payload) => {
  if (payload == null) return null;
  if (typeof payload === "object" && "data" in payload) return payload.data;
  return payload;
};

export const scheduledMessagesService = {
  async list({ status } = {}) {
    const qs = status && status !== "ALL" ? `?status=${encodeURIComponent(status)}` : "";
    const data = await request(`${BASE}${qs}`, { method: "GET" });
    return pickData(data) || [];
  },

  async get(id) {
    const data = await request(`${BASE}/${id}`, { method: "GET" });
    return pickData(data);
  },

  async create(payload) {
    const data = await request(`${BASE}`, { method: "POST", body: payload });
    return pickData(data);
  },

  async cancel(id) {
    const data = await request(`${BASE}/${id}/cancel`, { method: "PUT" });
    return pickData(data);
  },
};
